import { useGetMessagingSettingsByEventIdQuery } from '@graphql/generated';
import { useMemo } from 'react';

const isValidUrl = (urlString: string) => {
  try {
    return Boolean(new URL(urlString));
  } catch (e) {
    return false;
  }
};

const useGetPostRsvpCustomRedirectUrl = ({ attending, eventId }: { attending: boolean; eventId: string }) => {
  const { data: messagingSettings, loading: messagingSettingsLoading } = useGetMessagingSettingsByEventIdQuery({ batchMode: 'fast', variables: { eventId }, skip: !eventId });

  const rsvpNoCustomRedirectEnabled = messagingSettings?.getMessagingSettingsByEventId?.rsvpNoCustomRedirectEnabled || false;
  const rsvpNoCustomRedirectUrl = messagingSettings?.getMessagingSettingsByEventId?.rsvpNoCustomRedirectUrl || '';

  const rsvpYesCustomRedirectEnabled = messagingSettings?.getMessagingSettingsByEventId?.rsvpYesCustomRedirectEnabled || false;
  const rsvpYesCustomRedirectUrl = messagingSettings?.getMessagingSettingsByEventId?.rsvpYesCustomRedirectUrl || '';

  const customRedirectUrl = useMemo(() => {
    if (attending && rsvpYesCustomRedirectEnabled) {
      return rsvpYesCustomRedirectUrl;
    } else if (!attending && rsvpNoCustomRedirectEnabled) {
      return rsvpNoCustomRedirectUrl;
    } else {
      return '';
    }
  }, [attending, rsvpYesCustomRedirectEnabled, rsvpYesCustomRedirectUrl, rsvpNoCustomRedirectEnabled, rsvpNoCustomRedirectUrl]);

  return useMemo(() => {
    return { messagingSettingsLoading, customRedirectUrl: isValidUrl(customRedirectUrl) ? customRedirectUrl : '' };
  }, [messagingSettingsLoading, customRedirectUrl]);
};

export default useGetPostRsvpCustomRedirectUrl;
